import { matchExtensionNameToMimetype, cdnDomain, fileIconSvgPath, fileIconPngPath } from "./const";
import { MatchMachine } from "./match-machine";
import { FileIconFormat } from "../lib/file-icon-url";
import { MimeType, DocType, PadType, docTypeToMimeTypeMap, padTypeToMimeTypeMap } from '@tencent/docs-mime-types';
/**
 * 适配没有 mimeType 的存量文件、mimeType 为 folder 的特殊文件夹。
 * 主要用于工具包入口函数推断和处理 mimeType
 * 如果匹配不到返回 undefined, 主调方需要处理 undefined 的情况
 */
export function mimetypeAdaptor(_ref) {
  var docType = _ref.docType,
    mimeTypeInput = _ref.mimeType,
    _ref$isCollaboration = _ref.isCollaboration,
    isCollaboration = _ref$isCollaboration === void 0 ? false : _ref$isCollaboration,
    ext = _ref.extensionName,
    padType = _ref.padType;
  var extensionName = ext === null || ext === void 0 ? void 0 : ext.toLocaleLowerCase();
  var mimeType = validateMimeType({
    docType: docType,
    mimeType: mimeTypeInput,
    extensionName: extensionName,
    padType: padType
  });

  // 没有mimeType 则使用padType 和 docType 进行推导
  if (!mimeType) {
    // 适配部分没有 mimeType 的存量文件和未知的 mimeType，未知的 mimeType 如果无法推断则采用拼接/兜底 URL
    mimeType = inferMimetype(docType, padType, extensionName);
  }

  // 是folder的情况
  if (mimeType === MimeType.Folder) {
    // 适配存量 mimeType 为 folder 的特殊文件夹，将特殊文件夹转换为对应的 mimeType
    mimeType = correctFolderMimetype(isCollaboration);
  }
  return mimeType;
}

/**
 * 通过 docType、padType 文件扩展名 推断 mimeType
 *
 * 主要用于存量文件没有 mimeType 和传入未知的 mimeType 的情景
 */
export function inferMimetype(docType, padType, extensionName) {
  if (isDrive(docType, padType) && extensionName) {
    var _extensionName;
    if (((_extensionName = extensionName) === null || _extensionName === void 0 ? void 0 : _extensionName.charAt(0)) === '.') {
      // 去掉文件扩展名可能含有的'.'
      extensionName = extensionName.substring(1);
    }
    var matchMachine = new MatchMachine({}, matchExtensionNameToMimetype);
    return matchMachine.run(extensionName) || MimeType.Default;
  }
  /**
   * 补充folder 推断的逻辑 
   */
  if (docType === DocType.Folder) {
    return MimeType.Folder;
  }

  // 在线文档根据 DocType 或者 PadType 推断 Mimetype，未知的 mimeType 使用拼接 URl
  return docTypeToMimeTypeMap[docType] || padTypeToMimeTypeMap[padType];
}
export function isDrive(docType, padType) {
  /**
   * 本地文件也是 Drive 文件
   **/
  if (docType) return docType === DocType.Drive || docType === DocType.LocalFile;
  // Drive的 padType 可能是【drive-X】 或者是 【drive】
  if (padType) return padType.indexOf(PadType.Drive) > -1;
  return false;
}

/**
 * 正规化文件夹的 mimeType，根据 isCollaboration（可能后面还有其他不同的特殊文件夹flag）返回对应的 mimeType。
 *
 * 主要用于适配存量文件夹中 mimeType 为 folder 的协作空间（可能后面还有用其他flag来标记的特殊文件夹）
 * 工具包中对不同文件夹使用不同 mimeType 进行标记和区分
 */
export function correctFolderMimetype(isCollaboration) {
  if (isCollaboration) {
    return MimeType.CollaborationSpace;
  }
  return MimeType.Folder;
}

/**
 *  参数检测
 *  如果接口返回错误了，则不要白屏
 */
function validateMimeType(params) {
  // 非drive的判断
  // 1. 没有docType 或者 docType 是 unknown
  // 2. 没有padType
  // 3. 没有MimeType 或者 mimeType为空串
  if ((params.docType === undefined || params.docType === DocType.Unknown) && !params.padType && !params.mimeType) {
    return MimeType.Default;
  }

  // Drive情况还需要判断是否有传后缀
  if (isDrive(params.docType, params.padType) && !params.extensionName && !params.mimeType) {
    return MimeType.Default;
  }
  return params.mimeType;
}
export var isBoolean = function isBoolean(target) {
  return Object.prototype.toString.call(target).slice(8, -1) === 'Boolean';
};
export var getConcatUrl = function getConcatUrl(mimeType, format) {
  if (format === FileIconFormat.PNG) {
    return cdnDomain + fileIconPngPath + mimeType.replace('/', '-') + '.png';
  }
  return cdnDomain + fileIconSvgPath + mimeType.replace('/', '-') + '.svg';
};
//# sourceMappingURL=utils.js.map